module.exports = __webpack_public_path__ + "img/icon-17.2909b669.svg";